import { Layer } from '@dustin-web/styledust/constants'

export const getLayerClassName = (layer: Layer) => `u-layer-${layer}`
